import Http from '../../../../network/Http'
import {ContentType} from '../../../../network/Constants'
import {NatPostResidentSsoLogin} from './NatPostResidentSsoLogin';

export interface PostSsoLoginParams {
    refreshToken: string
    condominiumCd: string
    ridgeCd: string
    roomNumber: string
}

export default class NatSsoRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // SSOログイン認証
    async postSsoLogin(requestParams: PostSsoLoginParams): Promise<NatPostResidentSsoLogin> {
        return await this.http.post(`/api/resident/ssoLogin`, {
                refreshToken: encodeURIComponent(requestParams.refreshToken),
                condominiumCd: encodeURIComponent(requestParams.condominiumCd),
                ridgeCd: encodeURIComponent(requestParams.ridgeCd),
                roomNumber: encodeURIComponent(requestParams.roomNumber),
            }, ContentType.JSON,
        )
    }

}
